/* oxlint-disable typescript/no-unsafe-assignment, typescript/no-unsafe-member-access */
import removeFromDOM from 'ember-metrics/-private/utils/remove-from-dom';
// @ts-expect-error - ember-metrics is not typed
import BaseAdapter from 'ember-metrics/metrics-adapters/base';
import window from 'ember-window-mock';

interface AdapterConfig {
  proxyDomain?: string;
  id?: string;
  dataLayer?: string;
}

// oxlint-disable-next-line typescript/consistent-type-assertions, typescript/no-explicit-any
const w = window as any;

export default class LocalGoogleTagManager extends BaseAdapter {
  declare config: AdapterConfig;

  toStringExtension() {
    return 'LocalGoogleTagManager';
  }

  init() {
    this.install();
  }

  install() {
    let {
      proxyDomain = 'https://www.googletagmanager.com/gtm.js',
      id = '',
      dataLayer = 'dataLayer',
    } = this.config;
    let d = w.document;
    w[dataLayer] = w[dataLayer] || [];
    w[dataLayer].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    let f = d.getElementsByTagName('script')[0];
    let j = d.createElement('script');
    let dl = dataLayer !== 'dataLayer' ? '&l=' + dataLayer : '';
    j.async = true;
    j.src = id ? proxyDomain + '?id=' + id + dl : proxyDomain;
    f.parentNode.insertBefore(j, f);
  }

  trackEvent(options: Record<string, unknown> = {}) {
    let { dataLayer = 'dataLayer' } = this.config;
    w[dataLayer].push({ event: options.event, ...options });
  }

  trackPage(options: Record<string, unknown> = {}) {
    let { dataLayer = 'dataLayer' } = this.config;
    w[dataLayer].push({ event: 'pageview', ...options });
  }

  uninstall() {
    let { proxyDomain = 'https://www.googletagmanager.com/gtm.js', dataLayer = 'dataLayer' } =
      this.config;
    removeFromDOM(`script[src*="${proxyDomain}"]`);
    // oxlint-disable-next-line typescript/no-dynamic-delete
    delete w[dataLayer];
  }

  willDestroy() {
    this.uninstall();
  }
}
